import { render, staticRenderFns } from "./ErrorAlertItem.vue?vue&type=template&id=bf0f50a0&scoped=true&"
import script from "./ErrorAlertItem.vue?vue&type=script&lang=js&"
export * from "./ErrorAlertItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0f50a0",
  null
  
)

export default component.exports